import React, { createContext, useContext, useState } from 'react';

const SidebarPermissionContext = createContext();

export const useSidebarPermission = () => {
    return useContext(SidebarPermissionContext);
};

export const SidebarPermissionProvider = ({ children }) => {
    const [permissions, setPermissions] = useState(null);
    const [isPermissionsLoaded, setIsPermissionsLoaded] = useState(false);

    const setPermissionsExternal = (newPermissions) => {
        setPermissions(Array.isArray(newPermissions) ? newPermissions : []);
        setIsPermissionsLoaded(true);
    };

    // Keep prior permissions while refreshing so the sidebar does not collapse to Home/Support.
    const beginPermissionsLoading = () => {
        setIsPermissionsLoaded(false);
    };

    const clearPermissions = () => {
        setPermissions(null);
        setIsPermissionsLoaded(false);
    };

    return (
        <SidebarPermissionContext.Provider value={{ permissions, setPermissions: setPermissionsExternal, beginPermissionsLoading, clearPermissions, isPermissionsLoaded }}>
            {children}
        </SidebarPermissionContext.Provider>
    );
};
